import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Form } from '@kuzmycz/react-form-ula';
import { Button, Modal, Tab } from '../../../../Components/uielements';
import BioPlusTextField from '../../../../Components/form-fields/BioPlusTextField';
import DropDown from '../../../../Components/uielements/dropDown';
import {
  ModalButtonWrapper,
  ModalGap,
  ModalWrapper,
  OutlineButton,
  TwoColumns,
} from '../../../../services/settings/appStyle/global.style';
import UserService from '../../../../services/bioplus-services/user';
// import { UserSchema } from '../validators/editUserValidator';
import { IntlMessages } from '../../../../helper/langHelper';
// import PermissionForm from './permissonForm';
import { TabContainer } from '../user.style';
import PermissionFormV2 from './permissionFormV2';
// import PermissionFormV2 from './permissionFormV2';

const getEditUserUrlBasedOnRole = async (userRole, editData) => {
  if (userRole === 'owner') {
    return await UserService.update(editData);
  } else if (userRole === 'partner') {
    return await UserService.updateByPartner(editData.partnerId, editData);
  }
};

const tabArray = [
  {
    buttonText: 'Edit',
    value: 'edit',
    textId: '1',
  },
  {
    buttonText: 'Permission',
    value: 'permission',
    textId: '2',
  },
];

const PartnerUserEditModal = ({ onClose, data, userRole, options = [], invalidateQuery }) => {
  const [selectedRole, setSelectedRole] = useState();
  const queryClient = useQueryClient();
  const [activeTab, setActiveTab] = useState('edit');

  const mutation = useMutation((user) => getEditUserUrlBasedOnRole(userRole, user), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(invalidateQuery);
      onClose();
    },
    onError: (error) => {
      console.log(error, 'error');
      alert(`Error: Something went wrong. Please try again later.`);
      onClose();
    },
  });

  const handleSubmit = (values) => {
    const value = {
      ...values,
      ...(selectedRole && { role: selectedRole }),
      ...(selectedRole === 'OWNER' && { label: 'PROPERTY MANAGER' }),
    };
    mutation.mutate(value);
  };

  const validator = (values) => {
    // return UserSchema.validate(values);
    return undefined;
  };

  const handleSelectedValue = (value) => {
    setSelectedRole(value.value);
  };

  const handleTabClick = (clickedTab) => {
    if (clickedTab) {
      setActiveTab(clickedTab);
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'edit':
        return (
          <Form initialValues={data} validator={validator} onSubmit={handleSubmit}>
            <ModalWrapper>
              <ModalGap>
                <TwoColumns>
                  <BioPlusTextField
                    name="userId.firstName"
                    label={<IntlMessages id="input.label.firstName" defaultValue="First Name" />}
                    fullWidth
                  />
                  <BioPlusTextField
                    name="userId.lastName"
                    label={<IntlMessages id="input.label.lastName" defaultValue="Last Name" />}
                    fullWidth
                  />
                </TwoColumns>
                <BioPlusTextField
                  name="userId.email"
                  label={<IntlMessages id="input.label.email" defaultValue="Email" />}
                  fullWidth
                  disabled
                />
                <BioPlusTextField
                  name="userId.phone"
                  label={<IntlMessages id="input.label.phone.no" defaultValue="Phone No" />}
                  fullWidth
                  disabled
                />
                <BioPlusTextField
                  name="companyId.name"
                  label={<IntlMessages id="input.label.company.name" defaultValue="Entity Name" />}
                  fullWidth
                />
                <DropDown
                  options={options}
                  selectedOption={handleSelectedValue}
                  name="role"
                  defaultValue={data.role}
                  label={<IntlMessages id="input.label.role" defaultValue="Role" />}
                />
              </ModalGap>
              <ModalButtonWrapper>
                <OutlineButton onClick={onClose}>
                  <IntlMessages id="modal.button.cancel" defaultValue="Cancel" />
                </OutlineButton>
                <Button varient="normal" type="submit">
                  <IntlMessages id="modal.button.submit" defaultValue="Submit" />
                </Button>
              </ModalButtonWrapper>
            </ModalWrapper>
          </Form>
        );
      case 'permission':
        return (
          <>
            <PermissionFormV2
              onClose={onClose}
              userData={data}
              isPartner={true}
              invalidateQuery={invalidateQuery}
            />
          </>
        );
      default:
        return null;
    }
  };
  return (
    <>
      <Modal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="modal.title.edit" defaultValue="Edit" />}
        isHeader={
          // data?.role === 'PARTNER' ? true :
          data?.role === 'ADMIN' ? true : false
        }
      >
        {
          // data?.role !== 'PARTNER' &&
          data?.role !== 'ADMIN' && (
            <TabContainer>
              <Tab buttonArray={tabArray} onButtonClick={handleTabClick} activeTab={activeTab} />
            </TabContainer>
          )
        }
        {renderTabContent()}
      </Modal>
    </>
  );
};

export default PartnerUserEditModal;
